import { Navigate, useLocation, useParams } from 'react-router-dom';
import StoreOrderPage from './StoreOrderPage';
import { selectionSearch } from 'components/paperwork/content';

// Older purchase links return to the website's explicit package/variant
// selection. A URL never adds an item or proves that an order was paid.
export default function PaperworkCheckoutPage({ packageId = '', resultState = '' }) {
  const params = useParams(), { search } = useLocation();
  const requested = packageId || params.packageId || '';
  const query = new URLSearchParams(search);
  const selection = { tier: requested, arrangement: query.get('arrangement'), equipment: query.get('equipment'), state: query.get('state') };
  if (resultState) return <StoreOrderPage />;
  return <Navigate replace to={{ pathname: '/paperwork', search: selectionSearch(search, selection) }} />;
}
